module.exports = __webpack_public_path__ + "static/media/plan-mas-250-gigas.747264fa.svg";